/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { AiOutlineMail, AiOutlinePlusCircle } from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";
import {
  BsBank,
  BsCheckCircle,
  BsCurrencyExchange,
  BsDoorOpen,
  BsFileEarmarkPdfFill,
  BsGearWideConnected,
  BsReverseLayoutTextWindowReverse,
  BsWalletFill,
} from "react-icons/bs";
import { FaMoneyBillAlt, FaUserAlt } from "react-icons/fa";
import { FcMoneyTransfer, FcRules, FcWorkflow } from "react-icons/fc";
import { FiAlertTriangle } from "react-icons/fi";
import { GiSandsOfTime } from "react-icons/gi";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { ImUpload, ImUsers } from "react-icons/im";
import { IoIosCreate } from "react-icons/io";
import {
  MdAccountBalanceWallet,
  MdOutlineAccountBalance,
  MdOutlineHistory,
  MdPayment,
  MdPending,
  MdRequestPage,
  MdSettings,
  MdSupportAgent,
} from "react-icons/md";
import { RiAddCircleLine } from "react-icons/ri";
import { SiKnown } from "react-icons/si";
import { VscVerified } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import cashSvg from "../../assets/images/svgs/cash.svg";
import document from "../../assets/images/svgs/document.svg";
import peopleSvg from "../../assets/images/svgs/people.svg";
import reportSvg from "../../assets/images/svgs/report.svg";
import transferSvg from "../../assets/images/svgs/transfer.svg";
import walletSvg from "../../assets/images/svgs/wallet.svg";
import {
  menuInitialStatus,
  menuType,
  userTypes,
} from "../../utils/helpers/constants";
import { getBaseUrl } from "../../utils/services/baseUrl";
import DigitalBankingMenu from "./DigitalBankingMenu";
import LoanMenu from "./LoanMenu";
import PayOutMenu from "./PayOutMenu";
import RemittanceMenu from "./RemittanceMenu";

const MenuLinks = ({ active, menu, domainBrand, profile, userModules }) => {
  const dropDownInitState = menuInitialStatus;
  const [dropDownStatus, updateDropDownStatus] = useState(dropDownInitState);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const reboundNav = (event, id) => {
    event.preventDefault();
    expandMenu(id);
  };

  const expandMenu = (idName) => {
    const dropDownData = { ...dropDownInitState, [idName]: true };
    updateDropDownStatus(dropDownData);
  };

  useEffect(() => {
    expandMenu(menu);
  }, [menu]);

  return (
    <React.Fragment>
      <li>
        <NavLink
          exact
          to="/"
          className={menu === menuType.HOME ? "active" : ""}
        >
          <svg
            width="28"
            height="24"
            viewBox="0 0 28 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.2857 7.64679V0.857143H18V3.98839L13.7143 0L0 12.8571H3.42857V24H11.1429V15.4286H16.2857V24H24V12.8571H27.4286L22.2857 7.64679Z"
              fill={"#6259CA"}
            />
          </svg>
          &nbsp;
          {languageStatus ? dictionary["para_home"] : "Home"}
        </NavLink>
      </li>
      {/* COMMON MENUS FOR MANAGER GOES HERE */}
      {/* CRM */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ? (
        <>
          {profile.userType === userTypes.MANAGER ? (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.CRM)}
                  exact
                  to="/crm"
                  className={menu === menuType.CRM ? "active" : ""}
                >
                  <img src={walletSvg} alt="homeSvg" /> &nbsp;
                  {languageStatus ? dictionary["WO_CR_-560706472"] : "CRM"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.CRM]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      {" "}
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="/customers" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["m_manage_customer"]
                            : "Customers"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("REMITTANCE") && (
                    <>
                      <li>
                        <NavLink
                          to="/awaiting-verification?TYPE=AWAITING"
                          className="slide-item"
                        >
                          <MdPending color={"#6259CA"} fontSize={25} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_AWAITING_VERIFICATIO_4608421"]
                            : "Awaiting Verification"}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/account-creation" className="slide-item">
                          <IoIosCreate color={"#6259CA"} fontSize={25} />
                          &nbsp; Account Creation
                        </NavLink>
                      </li>
                    </>
                  )}
                  {userModules?.includes("LENDING") ? (
                    <>
                      {/* <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp; Profile
                        </NavLink>
                      </li> */}
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp; List Loan
                        </NavLink>
                      </li>
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp; Restructure Payment
                        </NavLink>
                      </li>
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp; Approval Loan Request
                        </NavLink>
                      </li>
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <ImUsers color={"#6259CA"} fontSize={25} />
                          &nbsp; Issue Unrequest Loan
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* COMPLIANCE */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
                  exact
                  to="/compliance"
                  className={menu === menuType.COMPLIANCE ? "active" : ""}
                >
                  <img src={walletSvg} alt="homeSvg" /> &nbsp;
                  {languageStatus
                    ? dictionary["m_compliance"]
                    : "Compliance"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.COMPLIANCE]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                  userModules?.includes("LENDING") ? (
                    <>
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="/kyc-rules" className="slide-item">
                          <SiKnown color={"#6259CA"} fontSize={24} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["KYCKNOW_YOUR_CUSTOM_723094592"]
                            : "KYC Rules"}
                        </NavLink>
                      </li>

                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink
                          to="/awaiting-verification?TYPE=AWAITING"
                          className="slide-item"
                        >
                          <VscVerified color={"#6259CA"} fontSize={24} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_AWAITING_VERIFICATIO_4608421"]
                            : "Awaiting Verification"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li>
                        <NavLink to="/aml-rules" className="slide-item">
                          <FcRules color={"#6259CA"} fontSize={24} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["m_transaction_rules"]
                            : "AML Rules"}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/transaction-alerts"
                          className="slide-item"
                        >
                          <FiAlertTriangle color={"#6259CA"} fontSize={24} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["para_transaction_alerts"]
                            : "Transaction Alerts"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* CONFIGURATIONS */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ||
      userModules?.includes("PAY_OUT_PARTNER") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  // onClick={(event) => reboundNav(event, menuType.SETTINGS)}
                  exact
                  to="/configurations"
                  className={menu === menuType.SETTINGS ? "active" : ""}
                >
                  <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp;
                  Configurations &nbsp;
                </NavLink>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* FEES */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.SECURITY)}
                  exact
                  to="/"
                  className={menu === menuType.FEE ? "active" : ""}
                >
                  <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Fee
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.SECURITY]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("LENDING") ||
                  userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      {/* <li className={active === "customer" ? "active" : ""}>
                        <NavLink to="" className="slide-item">
                          <MdSettings color={"#6259CA"} fontSize={25} />
                          &nbsp; Set up
                        </NavLink>
                      </li> */}
                      <li className={active === "customer" ? "active" : ""}>
                        <NavLink
                          to="/settings/remittance-settings"
                          className="slide-item"
                        >
                          <MdSettings color={"#6259CA"} fontSize={25} />
                          &nbsp; Cross-Border Transfer
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li>
                        <NavLink
                          to="/fee/payment-method"
                          className="slide-item"
                        >
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp; Payment Method
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/settings/rates"
                          className="slide-item"
                          style={{ fontSize: "15px" }}
                        >
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp; Exchange Rates
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li>
                        <NavLink
                          to="/settings/interest-rate"
                          className="slide-item"
                          style={{ fontSize: "15px" }}
                        >
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_INTEREST_RAT_1193574154"]
                            : "Account Maintenance Fee"}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          onClick={(event) =>
                            reboundNav(event, menuType.TRANSFER)
                          }
                          exact
                          to="/transfer"
                          className={menu === menuType.TRANSFER ? "active" : ""}
                        >
                          <img src={transferSvg} alt="arrowRight" /> &nbsp;
                          {languageStatus
                            ? dictionary["m_wallet_fund_transfer"]
                            : "Transfers"}{" "}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* MANGEMENT --> COMMENT FOR NOW */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("LENDING") ||
      userModules?.includes("PAY_OUT_PARTNER") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.MANAGEMENT)}
                  exact
                  to="/management"
                  className={menu === menuType.MANAGEMENT ? "active" : ""}
                >
                  <img src={walletSvg} alt="homeSvg" /> &nbsp;
                  {languageStatus
                    ? dictionary["para_management"]
                    : "Management"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.MANAGEMENT]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  <>
                    {userModules?.includes("DIGITAL_BANKING") ||
                    userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                    userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                    userModules?.includes("REMITTANCE") ||
                    userModules?.includes("PAY_OUT_PARTNER") ? (
                      <li className={active === "management" ? "active" : ""}>
                        <NavLink
                          to="/management/partner-agents"
                          className="slide-item"
                        >
                          <FaUserAlt
                            color={"#6259CA"}
                            fontSize={20}
                            fill={"#6259CA"}
                          />
                          &nbsp;{" "}
                          {dictionary
                            ? dictionary["m_trading_partners"]
                            : "Partners/Agents/Branches"}
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}

                    {userModules?.includes("DIGITAL_BANKING") ||
                    userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                    userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                    userModules?.includes("PAY_OUT_PARTNER") ? (
                      <>
                        <li>
                          <NavLink
                            to="/management/employees"
                            className="slide-item"
                          >
                            <GrUserWorker
                              color={"#6259CA"}
                              fontSize={24}
                              fill={"#6259CA"}
                            />
                            &nbsp; Employees
                          </NavLink>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </>

                  {userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                  userModules?.includes("PAY_OUT_PARTNER") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <FaUserAlt
                            color={"#6259CA"}
                            fontSize={20}
                            fill={"#6259CA"}
                          />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_APPROVEDISAPPROVE_P_36761235"]
                            : "Approve/Disapprove Agents"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("PAY_OUT_PARTNER") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                  userModules?.includes("LENDING") ? (
                    <>
                      <li
                        className={active === "app/dis/cashier" ? "active" : ""}
                      >
                        <NavLink
                          exact
                          to="/management/approve-disapprove-cashier"
                          className="slide-item"
                        >
                          <FaUserAlt fontSize={20} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                            : "Approve/Disapprove Cashier Profiles"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
                  userModules?.includes("PAY_OUT_PARTNER") ? (
                    <>
                      <li>
                        <NavLink
                          to="/management/bulk-upload"
                          className="slide-item"
                        >
                          <ImUpload
                            color={"#6259CA"}
                            fontSize={24}
                            fill={"#6259CA"}
                          />
                          &nbsp; Import Data from File
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* PRODUCTS */}
      {userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <li>
              <NavLink
                onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
                exact
                to=""
                className={menu === menuType.PRODUCTS ? "active" : ""}
              >
                <img src={walletSvg} alt="homeSvg" /> &nbsp;
                {languageStatus
                  ? dictionary["WO_PRODUCT_-541446518"]
                  : "Products"}{" "}
                &nbsp;
                <i className="fa fa-angle-down float end horizontal-icon" />
              </NavLink>
              <ul
                className={`sub-menu ${
                  dropDownStatus[menuType.COMPLIANCE]
                    ? "submenu-dropdown"
                    : "no-dropdown"
                }`}
              >
                {userModules?.includes("LENDING") ? (
                  <>
                    {" "}
                    <li className={active === "customer" ? "active" : ""}>
                      <NavLink
                        to="/settings/rates?type=add-interest-rate"
                        className="slide-item"
                      >
                        <AiOutlinePlusCircle color={"#6259CA"} fontSize={24} />
                        &nbsp; Add New Interest Rate
                      </NavLink>
                    </li>
                    <li className={active === "customer" ? "active" : ""}>
                      <NavLink
                        to="/product/loan?product-type=LOAN"
                        className="slide-item"
                      >
                        <AiOutlinePlusCircle color={"#6259CA"} fontSize={24} />
                        &nbsp; Add New Loan Products
                      </NavLink>
                    </li>
                    <li className={active === "customer" ? "active" : ""}>
                      <NavLink to="" className="slide-item">
                        <BsCheckCircle color={"#6259CA"} fontSize={22} />
                        &nbsp; Approval Loan Request
                      </NavLink>
                    </li>
                  </>
                ) : (
                  ""
                )}

                {userModules?.includes("DIGITAL_BANKING") ||
                userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                  <>
                    {" "}
                    <li className={active === "customer" ? "active" : ""}>
                      <NavLink
                        to="/product/account-product?product-type=DEPOSIT"
                        className="slide-item"
                      >
                        <BsBank color={"#6259CA"} fontSize={22} />
                        &nbsp;&nbsp;
                        {languageStatus
                          ? dictionary["WO_ACCOUN_93052003"]
                          : "Account"}
                      </NavLink>
                    </li>
                    <li className={active === "loan" ? "active" : ""}>
                      <NavLink
                        to="/product/loan?product-type=LOAN"
                        className="slide-item"
                      >
                        <BsBank color={"#6259CA"} fontSize={22} />
                        &nbsp;&nbsp;
                        {languageStatus
                          ? dictionary["WO_LOA_-1193075533"]
                          : "Loan"}
                      </NavLink>
                    </li>
                  </>
                ) : (
                  ""
                )}
              </ul>
            </li>
          )}
        </>
      ) : (
        ""
      )}

      {/* REPORTS */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ||
      userModules?.includes("PAY_OUT_PARTNER") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.REPORTS)}
                  exact
                  to="/crm"
                  className={menu === menuType.REPORTS ? "active" : ""}
                >
                  <img src={walletSvg} alt="homeSvg" /> &nbsp;
                  {languageStatus ? dictionary["para_reports"] : "Reports"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.REPORTS]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink exact to="/statement" className="slide-item">
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp; Account Statement
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("REMITTANCE") && (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp; Payin
                        </NavLink>
                      </li>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/api-transaction-report"
                          className="slide-item"
                        >
                          <img src={reportSvg} alt="arrowRight" /> &nbsp;
                          {languageStatus
                            ? dictionary["m_transactions3"]
                            : "Payout"}
                        </NavLink>
                      </li>
                    </>
                  )}

                  {userModules?.includes("LENDING") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          // to="/report/my-transactions"
                          to=""
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp; Loan Account Performance
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("PAY_OUT_PARTNER") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/api-transaction-report"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_EXTERNAL_PARTY_PAYO_189399001"]
                            : "External Party Pay-out"}
                        </NavLink>
                      </li>

                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/unlock-transaction"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_UNLOCK_TRANSACTIO_-1638858905"]
                            : "Unlock Transaction"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* TREASURY */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.TREASURY)}
                  exact
                  to="/security"
                  className={menu === menuType.TREASURY ? "active" : ""}
                >
                  <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Treasury
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu sub-menu-top ${
                    dropDownStatus[menuType.SECURITY]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {/* <li className={active === "customer" ? "active" : ""}>
                    <NavLink
                      to="/fund-treasury-accounts"
                      className="slide-item"
                    >
                      <MdSettings color={"#6259CA"} fontSize={25} />
                      &nbsp;
                      {dictionary
                        ? dictionary["WO_FUND_MASTER_WALLE_-80712300"]
                        : "Fund Treasury Account (working capital)"}
                    </NavLink>
                  </li> */}
                  <li className={active === "customer" ? "active" : ""}>
                    <NavLink to="/treasury-accounts" className="slide-item">
                      <MdSettings color={"#6259CA"} fontSize={25} />
                      &nbsp;{" "}
                      {dictionary
                        ? dictionary["WO_MASTER_WALLET_ACCOUN_-1763093340"]
                        : "View Treasury Account"}
                    </NavLink>
                  </li>
                  {/* <li className={active === "customer" ? "active" : ""}>
                    <NavLink to="" className="slide-item">
                      <MdSettings color={"#6259CA"} fontSize={25} />
                      &nbsp; Withdraw from Treasury Account
                    </NavLink>
                  </li> */}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* CROSS BORDER */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ? (
        <>
          {profile.userType === userTypes.MANAGER && (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.CROSSBORDER)}
                  exact
                  to=""
                  className={menu === menuType.CROSSBORDER ? "active" : ""}
                >
                  <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Cross
                  Border &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu sub-menu-top ${
                    dropDownStatus[menuType.CROSSBORDER]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ? (
                    <>
                      <li className={active === "corridors" ? "active" : ""}>
                        <NavLink
                          to="/settings/transaction-corridors"
                          className="slide-item"
                        >
                          <BsDoorOpen
                            color={"#6259CA"}
                            fontSize={20}
                            fill={"#6259CA"}
                          />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_CORRIDOR_166705112"]
                            : "Corridors"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("LENDING") ||
                  userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      {/* <li>
                        <NavLink to="" className="slide-item">
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp; Setup
                        </NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/cross-border/tax" className="slide-item">
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp; Tax
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/settings/bank-account-settings"
                          className="slide-item"
                        >
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_BANK_FIELD_951387132"]
                            : "Bank Fields"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li>
                        <NavLink
                          to="/settings/remittance-settings"
                          className="slide-item"
                        >
                          <MdSettings color={"#6259CA"} fontSize={20} />
                          &nbsp; Cross-Border Transfer fee
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          )}
        </>
      ) : (
        ""
      )}

      {/* MERCHANTS */}
      {/* {userModules?.includes("REMITTANCE")} */}

      {/* COMMON MENU FOR CASHIER GOES HERE */}
      {/* TRANSACTION */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
        <>
          {profile.userType === userTypes.CASHIER ? (
            <li>
              <NavLink
                exact
                to="/"
                className={menu === menuType.TRANSACTIONS ? "active" : ""}
              >
                <img src={reportSvg} alt="arrowRight" /> &nbsp;
                {languageStatus
                  ? dictionary["para_transaction"]
                  : "Transaction"}{" "}
                &nbsp;
                <i className="fa fa-angle-down horizontal-icon" />
              </NavLink>
              <ul
                className={`sub-menu ${
                  dropDownStatus[menuType.REPORTS]
                    ? "submenu-dropdown"
                    : "no-dropdown"
                }`}
              >
                {userModules?.includes("REMITTANCE") ? (
                  <>
                    <li className={active === "billPayment" ? "active" : ""}>
                      <NavLink exact to="/payout-search" className="slide-item">
                        <BiTransfer fontSize={24} color={"#6259CA"} />
                        &nbsp;
                        {languageStatus
                          ? dictionary["para_pay_out"]
                          : "Pay Out"}
                      </NavLink>
                    </li>

                    <li className={active === "transfers" ? "active" : ""}>
                      <NavLink exact to="/transfer" className="slide-item">
                        <FcMoneyTransfer fontSize={25} color={"#6259CA"} />
                        &nbsp;
                        {languageStatus
                          ? dictionary["m_send_money"]
                          : "Send money"}
                      </NavLink>
                    </li>
                  </>
                ) : (
                  ""
                )}

                {userModules?.includes("REMITTANCE") ||
                userModules?.includes("DIGITAL_BANKING") ||
                userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                  <>
                    {domainBrand.serviceControl.billPayment ? (
                      <li className={active === "billPayment" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/bill-payment"
                          className="slide-item"
                        >
                          <MdPayment fontSize={24} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_BILL_PAYMEN_-1233806888"]
                            : "Bill Payments"}
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}
                    {userModules?.includes("DIGITAL_BANKING") ||
                    userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                    userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                      <>
                        <li
                          className={active === "transactions" ? "active" : ""}
                        >
                          <NavLink
                            exact
                            to="/fund-wallet"
                            className="slide-item"
                          >
                            <RiAddCircleLine fontSize={25} color={"#6259CA"} />
                            &nbsp; Fund Customer Account
                          </NavLink>
                        </li>
                        {domainBrand.serviceControl.transfer && (
                          <li
                            className={active === "transfers" ? "active" : ""}
                          >
                            <NavLink
                              exact
                              to="/transfer"
                              className="slide-item"
                            >
                              <FcMoneyTransfer
                                fontSize={25}
                                color={"#6259CA"}
                              />
                              &nbsp;
                              {languageStatus
                                ? dictionary["WO_TRANSFER_FUND_-1694451190"]
                                : "Transfer Funds"}
                            </NavLink>
                          </li>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </ul>
            </li>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* REPORTS */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("LENDING") ||
      userModules?.includes("PAY_OUT_PARTNER") ? (
        <>
          {profile.userType === userTypes.CASHIER && (
            <React.Fragment>
              <li>
                <NavLink
                  exact
                  to="/"
                  className={menu === menuType.REPORTS ? "active" : ""}
                >
                  <img src={reportSvg} alt="arrowRight" /> &nbsp;
                  {languageStatus ? dictionary["para_reports"] : "Reports"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.REPORTS]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li className={active === "statement" ? "active" : ""}>
                        <NavLink exact to="/statement" className="slide-item">
                          <BsFileEarmarkPdfFill
                            fontSize={24}
                            color={"#6259CA"}
                          />
                          &nbsp;
                          {languageStatus
                            ? dictionary["l_wallet_transaction_history"]
                            : "Account Statement"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("PAY_OUT_PARTNER") ? (
                    <>
                      <li className={active === "payin" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp; Payin
                        </NavLink>
                      </li>

                      <li className={active === "payout" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/api-transaction-report"
                          className="slide-item"
                        >
                          <img src={reportSvg} alt="arrowRight" /> &nbsp;
                          {languageStatus
                            ? dictionary["m_transactions3"]
                            : "Payout"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </React.Fragment>
          )}
        </>
      ) : (
        ""
      )}

      {/* COMMON MENU FOR CUSTOMER GOES HERE */}
      {/* BENEFICIARIES */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
        <>
          {profile.userType === userTypes.CUSTOMER ? (
            <>
              <li>
                <NavLink
                  exact
                  to="/beneficiaries"
                  className={
                    menu === menuType.BENEFICIARY
                      ? "sub-icon active"
                      : "sub-icon"
                  }
                >
                  <img src={peopleSvg} alt="arrowRight" /> &nbsp;
                  {languageStatus
                    ? dictionary["WO_BENEFICIARIE_-1845397122"]
                    : "Beneficiaries"}
                </NavLink>
              </li>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* TRANSACTION */}
      {userModules?.includes("LENDING") ||
      userModules?.includes("REMITTANCE") ? (
        <>
          {profile.userType === userTypes.CUSTOMER && (
            <li>
              <NavLink
                exact
                to="/"
                className={menu === menuType.TRANSACTIONS ? "active" : ""}
              >
                <img src={reportSvg} alt="arrowRight" /> &nbsp;
                {languageStatus
                  ? dictionary["para_transaction"]
                  : "Transaction"}{" "}
                &nbsp;
                <i className="fa fa-angle-down horizontal-icon" />
              </NavLink>
              <ul
                className={`sub-menu ${
                  dropDownStatus[menuType.REPORTS]
                    ? "submenu-dropdown"
                    : "no-dropdown"
                }`}
              >
                {userModules?.includes("REMITTANCE") ? (
                  <>
                    {domainBrand.serviceControl.airtimeTopup ? (
                      <li className={active === "airtime" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/airtime-topup"
                          className="slide-item"
                        >
                          <GiSandsOfTime fontSize={24} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["m_mobile_top_up"]
                            : "Airtime Topup"}
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}
                    {domainBrand.serviceControl.billPayment ? (
                      <li className={active === "billPayment" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/bill-payment"
                          className="slide-item"
                        >
                          <MdPayment fontSize={24} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_BILL_PAYMEN_-1233806888"]
                            : "Bill Payments"}
                        </NavLink>
                      </li>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
                {userModules?.includes("LENDING") ? (
                  <>
                    <li className={active === "transactions" ? "active" : ""}>
                      <NavLink exact to="" className="slide-item">
                        <MdAccountBalanceWallet
                          fontSize={25}
                          color={"#6259CA"}
                        />
                        &nbsp; Apply for Loan
                      </NavLink>
                    </li>
                    <li className={active === "transactions" ? "active" : ""}>
                      <NavLink exact to="" className="slide-item">
                        <MdAccountBalanceWallet
                          fontSize={25}
                          color={"#6259CA"}
                        />
                        &nbsp; Repay Loan
                      </NavLink>
                    </li>
                    <li className={active === "products" ? "active" : ""}>
                      <NavLink
                        exact
                        to="/customer-products"
                        className="slide-item"
                      >
                        <MdAccountBalanceWallet
                          fontSize={25}
                          color={"#6259CA"}
                        />
                        &nbsp; List available Loan Products
                      </NavLink>
                    </li>
                    <li className={active === "products" ? "active" : ""}>
                      <NavLink
                        exact
                        to="/customer-products"
                        className="slide-item"
                      >
                        <MdAccountBalanceWallet
                          fontSize={25}
                          color={"#6259CA"}
                        />
                        &nbsp; List my Loan Products
                      </NavLink>
                    </li>
                  </>
                ) : (
                  ""
                )}
              </ul>
            </li>
          )}
        </>
      ) : (
        ""
      )}

      {/* COMMON MENUS FOR BRANCH_ADMINS // AGENTS GOES HERE */}
      {/* REPORTS */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("PAY_OUT_PARTNER") ? (
        <>
          {profile.userType === userTypes.BRANCH_ADMIN ||
          profile.userType === userTypes.AGENTS ? (
            <React.Fragment>
              <li>
                <NavLink
                  exact
                  to="/"
                  className={menu === menuType.REPORTS ? "active" : ""}
                >
                  <img src={reportSvg} alt="arrowRight" /> &nbsp;
                  {languageStatus ? dictionary["para_reports"] : "Reports"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.REPORTS]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp; Payin
                        </NavLink>
                      </li>

                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/api-transaction-report"
                          className="slide-item"
                        >
                          <img src={reportSvg} alt="arrowRight" /> &nbsp;
                          {languageStatus
                            ? dictionary["m_transactions3"]
                            : "Payout"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <li className={active === "reports" ? "active" : ""}>
                      <NavLink
                        exact
                        to="/report/my-transactions"
                        className="slide-item"
                      >
                        <BiTransfer fontSize={25} color={"#6259CA"} />
                        &nbsp; Branch Ledger Activities
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}

                  {userModules?.includes("PAY_OUT_PARTNER") ? (
                    <>
                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_EXTERNAL_PARTY_PAYO_189399001"]
                            : "External Party Pay-out"}
                        </NavLink>
                      </li>

                      <li className={active === "reports" ? "active" : ""}>
                        <NavLink
                          exact
                          to="/report/my-transactions"
                          className="slide-item"
                        >
                          <BiTransfer fontSize={25} color={"#6259CA"} />
                          &nbsp;
                          {languageStatus
                            ? dictionary["WO_UNLOCK_TRANSACTIO_-1638858905"]
                            : "Unlock Transaction"}
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </React.Fragment>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* MANAGEMENT */}
      {userModules?.includes("REMITTANCE") ||
      userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ||
      userModules?.includes("PAY_OUT_PARTNER") ? (
        <>
          {profile.userType === userTypes.BRANCH_ADMIN ||
          profile.userType === userTypes.AGENTS ? (
            <>
              <li>
                <NavLink
                  onClick={(event) => reboundNav(event, menuType.MANAGEMENT)}
                  exact
                  to="/management"
                  className={menu === menuType.MANAGEMENT ? "active" : ""}
                >
                  <img src={walletSvg} alt="homeSvg" /> &nbsp;
                  {languageStatus
                    ? dictionary["para_management"]
                    : "Management"}{" "}
                  &nbsp;
                  <i className="fa fa-angle-down float end horizontal-icon" />
                </NavLink>
                <ul
                  className={`sub-menu ${
                    dropDownStatus[menuType.MANAGEMENT]
                      ? "submenu-dropdown"
                      : "no-dropdown"
                  }`}
                >
                  {userModules?.includes("REMITTANCE") ||
                  userModules?.includes("PAY_OUT_PARTNER") ||
                  userModules?.includes("DIGITAL_BANKING") ||
                  userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
                  userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
                    <>
                      <li className={active === "management" ? "active" : ""}>
                        <NavLink to="/management/agents" className="slide-item">
                          <FaUserAlt
                            color={"#6259CA"}
                            fontSize={20}
                            fill={"#6259CA"}
                          />
                          &nbsp; Approve/Disapprove Cashier Profiles
                        </NavLink>
                      </li>

                      <li className={active === "management" ? "active" : ""}>
                        <NavLink
                          to="/management/employees"
                          className="slide-item"
                        >
                          <GrUserWorker
                            color={"#6259CA"}
                            fontSize={24}
                            fill={"#6259CA"}
                          />
                          &nbsp; Employees
                        </NavLink>
                      </li>

                      <li className={active === "management" ? "active" : ""}>
                        <NavLink
                          to="/management/bulk-upload"
                          className="slide-item"
                        >
                          <ImUpload
                            color={"#6259CA"}
                            fontSize={24}
                            fill={"#6259CA"}
                          />
                          &nbsp; Import Data from File
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                </ul>
              </li>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* MODULE MENUES GOES HERE */}
      {userModules?.includes("REMITTANCE") && (
        <RemittanceMenu
          active={active}
          menu={menu}
          domainBrand={domainBrand}
          profile={profile}
          userModules={userModules}
        />
      )}

      {userModules?.includes("DIGITAL_BANKING") ||
      userModules?.includes("ELECTRONIC_MONEY_SERVICES") ||
      userModules?.includes("WALLET_ACCOUNT_MANAGEMENT") ? (
        <DigitalBankingMenu
          active={active}
          menu={menu}
          domainBrand={domainBrand}
          profile={profile}
          userModules={userModules}
        />
      ) : (
        ""
      )}

      {userModules?.includes("LENDING") && (
        <LoanMenu
          active={active}
          menu={menu}
          domainBrand={domainBrand}
          profile={profile}
          userModules={userModules}
        />
      )}

      {userModules?.includes("PAY_OUT_PARTNER") && (
        <PayOutMenu
          active={active}
          menu={menu}
          domainBrand={domainBrand}
          profile={profile}
          userModules={userModules}
        />
      )}
    </React.Fragment>
  );
};

export default MenuLinks;

// NOTES
// DIGITAL_BANKING, REMITTANCES, NEO BANKING, ELECTRONIC MONEY SERVICES
